import React from "react"
import FontAwesome from "react-fontawesome"
import PropTypes from "prop-types"
import GridViewCard from "../GridViewCard"
import "./DepartmentCard.scss"
import { maybePluralize } from "../../helpers/sharedHelperFunctions"

const DepartmentCard = props => {
  return (
    <div className="DepartmentCard">
      <GridViewCard
        name={props.name}
        compliance={props.compliance}
        opportunities={props.opportunities}
      >
        <div hidden={!props.facilityName}>
          <div className="facility-icon" />
          {props.facilityName}
        </div>
        <div>
          <FontAwesome name="user" />
          {maybePluralize(props.staffCount, "Staff", "Staff")}
        </div>
        <div className="detail-with-svg">
          <div className="opportunities-icon" />
          {maybePluralize(props.opportunities, "Opportunity", "Opportunities")}
        </div>
      </GridViewCard>
    </div>
  )
}

DepartmentCard.propTypes = {
  name: PropTypes.string.isRequired,
  facilityName: PropTypes.string,
  compliance: PropTypes.number,
  opportunities: PropTypes.number,
  staffCount: PropTypes.number,
}

DepartmentCard.defaultProps = {
  compliance: null,
  opportunities: 0,
  staffCount: 0,
}

export default DepartmentCard
